import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface IGroupFormDialogResult {
    name: string;
    totalName: string;
    financialLineItems: INameId[] | null;
}
